'use strict';
var trackingUtils = require('../modules/utils/tracking.utils');

Odigeo.defineWidget('chat_manager', Odigeo.Widget.extend({

    modelClass: Odigeo.Model.extend({

        isChatValid: false,
        isBubbleOpen: false,
        isChatOpen: false,
        countryCET: '+1',
        countryCEST: '+2',
        price: 0,
        daysOfWeek: ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'],
        timeRangeAccepted: {},
        subject: '',
        oGenesysWebChat: null,
        buyer: {},
        validChatManagerCases: ['COLLECTION_WRONG_CVV2', 'COLLECTION_INSUFFICIENT_CREDIT', 'COLLECTION_WRONG_CREDITCARD_EXPIRATION_DATE',
            'COLLECTION_WRONG_ELV_ACCOUNT', 'COLLECTION_UNSUPPORTED_GATEWAY_COLLECTION_METHOD', 'COLLECTION_ORDER_NOT_AUTHORIZE',
            'COLLECTION_CARD_NOT_IN_AUTHORIZERS_DB', 'COLLECTION_ACQUIRER_UNAVAILABLE', 'COLLECTION_INVALID_CARD_NUMBER',
            'COLLECTION_CARD_EXPIRED', 'COLLECTION_DATA_VALIDATION_ERROR', 'COLLECTION_INVALID_AMOUNT', 'COLLECTION_INVALID_CURRENCY',
            'COLLECTION_DECLINED', 'COLLECTION_AMOUNT_HIGHER_THAN_ALLOWED', 'BOOKING_PAYMENT_RETRY', 'USER_INTERACTION',
        ],

        init: function() {
            this.widget.options = Odigeo.parseOptions(this.widget.options);
            this.isChatValid = _.chain(this.widget.options)
                .omit(['isGenesysActiveOnPayment', 'isGenesysActiveOnHelpCenter'])
                .values()
                .every()
                .value();
            this.set('setValuesInitialized', false);
            this.timeRangeAccepted = this.defineTimeRangeValid(this.widget.options.chatTimerRange);
        },

        setValues: function() {
            if (!this.get('setValuesInitialized')) {
                var passengersData = JSON.parse(Odigeo.Session.get('passengersData'));
                if (passengersData) {
                    this.buyer = _.extend(passengersData.buyer,
                        {'name': passengersData.passengers0.name,
'lastName': passengersData.passengers0.lastName});
                }
                this.set('setValuesInitialized', true);
            }
        },

        loadChat: function() {
            this.setValues();
            var buyer = this.buyer;
            var chatConfig = this.widget.options.chatConfig;
            var formData = _.isEmpty(buyer) ? {} : {
                email: buyer.mail,
            };
            var userData = _.isEmpty(buyer) ? {} : {
                Nickname: buyer.name + ' ' + buyer.lastName,
                FirstName: buyer.name,
                LastName: buyer.lastName,
                EmailAddress: buyer.mail,
                CustomerPhoneNumber: buyer.phoneNumber1,
                BookingAmount: this.price,
            };
            if (!_.isObject(this.subject)) {
                userData = _.extend(userData, {
                    ContactCenter: chatConfig.ContactCenter,
                    Language: chatConfig.language,
                    PaymentError: this.subject,
                    Service: 'chat_paymentError',
                });
            }
            chatConfig.subject = this.subject;
            Odigeo.require(['GenesysWebChat'], _.bind(function(GenesysWebChat) {
                this.oGenesysWebChat = new GenesysWebChat({
                    'userData': userData || {},
                    'formData': formData,
                    'transport': 'apg',
                    'id': this.widget.options.chatId,
                    'dataURL': this.widget.options.chatUrl,
                    'CSRFURL': this.widget.options.chatCSRFUrl,
                    'template': '#genesys_webchat_123',
                    'title': chatConfig.ChatTitle,
                    'i18n_lang': chatConfig.language.toLowerCase(),
                    'i18n_messages': chatConfig,
                });
                this.oGenesysWebChat.open();
                this.oGenesysWebChat.startSession();
            }, this));
            trackingUtils.trackEvent('genesys_chat', 'chat_start');
        },

        requestHelpCustomersChat: function(error) {
            if (this.model.isChatAvailable() && _.includes(this.validChatManagerCases, error)) {
                this.startChat();
                this.model.subject = error;
            }
        },

        isChatAvailable: function() {
            var isValid = this.isChatValid && !this.isChatOpen && this.isInTimeRange();
            Odigeo.trigger(this.widget.id + ':validChat', isValid);
            return isValid;
        },

        splitTimeRange: function(validChatTimeRange) {
            var daySegmentInit = validChatTimeRange['init'].split(':');
            var daySegmentEnd = validChatTimeRange['end'].split(':');
            return {
                'initHour': parseInt(daySegmentInit[0], 10),
                'initMin': parseInt(daySegmentInit[1], 10),
                'endHour': parseInt(daySegmentEnd[0], 10),
                'endMin': parseInt(daySegmentEnd[1], 10),
            };
        },

        defineTimeRangeValid: function(timeRange) {
            return !timeRange ? {} : {
                'regularDay': [this.splitTimeRange(timeRange[0]['regularday'][0])],
                'saturday': [this.splitTimeRange(timeRange[1]['saturday'][0])],
                'sunday': [this.splitTimeRange(timeRange[2]['sunday'][0])],
            };
        },

        isInTimeRange: function() {
            var offset = this.isDST() ? this.countryCEST : this.countryCET;
            var requestDate = this.getUTCtime(offset);
            var day = requestDate.getDay();
            var kindOfDay = 0 < day && 6 > day ? 'regularDay' : this.daysOfWeek[day];
            var date = new Date();
            var customerServiceInit = 0;
            var customerServiceEnd = 0;

            if (!_.isEmpty(this.timeRangeAccepted)) {
                customerServiceInit = new Date(date.getFullYear(), date.getMonth(), date.getDate(),
                    this.timeRangeAccepted[kindOfDay][0].initHour, this.timeRangeAccepted[kindOfDay][0].initMin, 0, 0);
                customerServiceEnd = new Date(date.getFullYear(), date.getMonth(), date.getDate(),
                    this.timeRangeAccepted[kindOfDay][0].endHour, this.timeRangeAccepted[kindOfDay][0].endMin, 0, 0);
            }
            return !!(requestDate > customerServiceInit && requestDate < customerServiceEnd);
        },

        isDST: function() {
            // Daylight saving time (DST)
            var initDST = this.lastSundayOfMonth(2);
            var endDST = this.lastSundayOfMonth(9);
            var customerServiceDate = this.getUTCtime(0);
            return !!(customerServiceDate > initDST && customerServiceDate < endDST);
        },

        lastSundayOfMonth: function(month) {
            var now = new Date();
            var lastDayOfMonth = new Date(Date.UTC(now.getUTCFullYear(), month, 31, 21, 59, 59));
            var dayOfWeek = lastDayOfMonth.getDay();
            var lastSunday = 31 - dayOfWeek;
            return new Date(Date.UTC(now.getUTCFullYear(), month, lastSunday, 21, 59, 59));
        },

        getUTCtime: function(offset) {
            var date = new Date();
            var utc = date.getTime() + (date.getTimezoneOffset() * 60 * 1000);
            return new Date(utc + (60 * 60 * 1000 * offset));
        },
    }),

    viewClass: Odigeo.View.extend({
        init: function() {
            this.$cachedSelectors.chatManagerBubble.on(Odigeo.Events.tap, _.bind(this.openChatPanel, this, 'USER_INTERACTION'));
        },

        selectors: {
            chatManagerChatWrapper: '.chatmanager_chat_wrapper',
            chatManagerCloseIconWrapper: '.chatmanager_close_icon_wrapper',
            chatManagerBubble: '.chatmanager_bubble',
            chatManager: '.chat_manager',
        },

        enableBubbleChat: function(page) {
            var isValidOnPayment = ('payment' === page && this.widget.options.isGenesysActiveOnPayment);
            var isValidOnHelpCenter = ('helpCenter' === page && this.widget.options.isGenesysActiveOnHelpCenter);
            if ((isValidOnPayment || isValidOnHelpCenter) && this.model.isChatValid) {
                Odigeo.addScrollListener({
                    name: 'chatManagerBubble',
                    fn: _.bind(this.toggleBubble, this, true),
                    justOnce: true,
                    start: 1,
                    pageName: Odigeo.History.getPageNameFromFragment(),
                });
            }
        },

        disableBubbleChat: function() {
            Odigeo.removeScrollListener('chatManagerBubble');
            this.closeChatPanel();
            this.toggleBubble(false);
        },

        toggleBubble: function(showBubble) {
            this.model.isBubbleOpen = showBubble && this.model.isChatAvailable();
            this.$cachedSelectors.chatManagerBubble.delay(1500).toggleClass('shown', showBubble);
            if (showBubble) {
                trackingUtils.trackEvent('genesys_chat', 'chat_appearances');
            }
        },

        openChatPanel: function(error) {
            if (!this.model.isChatOpen) {
                this.model.isChatOpen = true;
                this.$cachedSelectors.chatManagerCloseIconWrapper.on(Odigeo.Events.tap, _.bind(this.closeChatPanel, this));
                if (this.widget.options.isGenesysActiveOnPayment) {
                    this.toggleBubble(false);
                }
                this.$cachedSelectors.chatManagerChatWrapper.addClass('shown');
                this.model.subject = error;
                this.model.initialConfiguration = false;
                this.startChat();
            }
        },

        startChat: function() {
            this.model.loadChat();
            trackingUtils.trackEvent('genesys_chat', 'chat_open');
        },

        closeChatPanel: function() {
            if (this.model.isChatOpen) {
                this.model.isChatOpen = false;
                this.$cachedSelectors.chatManagerCloseIconWrapper.off(Odigeo.Events.tap);
                if (this.widget.options.isGenesysActiveOnPayment) {
                    this.model.isBubbleOpen = true;
                    this.model.oGenesysWebChat.close();
                    this.$cachedSelectors.chatManagerChatWrapper.removeClass('shown');
                } else {
                    this.$cachedSelectors.chatManagerChatWrapper.slideUp(500);
                    this.model.oGenesysWebChat.close();
                }
            }
        },
    }),

    execute: function(fn) {
        var args = [].slice.call(arguments, 1);
        switch (fn) {
            case 'requestHelpCustomersChat':
                this.model.requestHelpCustomersChat.apply(this, args);
                break;
            case 'isChatAvailable':
                this.model.isChatAvailable.apply(this.model, args);
                break;
            case 'updatePrice':
                this.model.price = args[0];
                break;
            case 'openChat':
                this.view.openChatPanel.apply(this.view, args);
                break;
            case 'enableBubbleChat':
                this.view.enableBubbleChat.apply(this.view, args);
                break;
            case 'disableBubbleChat':
                this.view.disableBubbleChat.apply(this.view, args);
                break;
            case 'setValues':
                this.model.setValues.apply(this.model, args);
                break;
        }
        return this;
    },

}));
